import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, withKeys as _withKeys, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3edf4176"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel-body" }
const _hoisted_2 = { class: "expansion-toggle" }
const _hoisted_3 = { class: "develop-week-step-wrapper" }
const _hoisted_4 = ["onClick", "onKeydown", "data-test"]
const _hoisted_5 = {
  key: 0,
  class: "step-completion-icon glyphicon glyphicon-ok"
}
const _hoisted_6 = {
  key: 1,
  class: "step-completion-icon"
}
const _hoisted_7 = { class: "step-text" }
const _hoisted_8 = { class: "step-title" }
const _hoisted_9 = { class: "step-subtitle" }

import { debug as d } from "debug";
import { PlanStepModel, PlanWeekModel } from "./develop-plan-models";
import StepIcon from "./step-icon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'develop-plan-week',
  props: {
    model: {},
    expanded: { type: Boolean, default: false }
  },
  emits: ["expand", "contract"],
  setup(__props: any, { emit: __emit }) {

const debug = d("cs.DevelopWeek");

const props = __props;

const emit = __emit;

function handleWeekClick(): void {
  debug("handleClick", props.expanded);
  if (!props.expanded) {
    emit("expand");
  } else {
    emit("contract");
  }
}

function handleStepClick(step: PlanStepModel): void {
  if (step.isAvailable) {
    window.location.href = `/resources/develop/${step.uid}`;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["develop-week panel tile-shadow panel-default", { expanded: _ctx.expanded }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (handleWeekClick())),
        onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (handleWeekClick()), ["space"])),
        class: "week-title",
        style: {"margin":"0","padding":"20px"}
      }, _toDisplayString(_ctx.model.title), 33),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.expanded ? "-" : "+"), 1),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.steps, (step) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["develop-step", {
            completed: step.isComplete,
            available: step.isAvailable,
            current: step.isCurrent,
          }]),
            onClick: ($event: any) => (handleStepClick(step)),
            onKeydown: _withKeys(($event: any) => (handleStepClick(step)), ["space"]),
            "data-test": step.isCurrent ? 'current-develop-step' : 'develop-step',
            key: step.id
          }, [
            (step.isComplete)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, "•")),
            _createVNode(StepIcon, {
              "day-or-page-type": step.dayOrPageType,
              "is-available": step.isAvailable,
              "is-current": step.isCurrent
            }, null, 8, ["day-or-page-type", "is-available", "is-current"]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(step.title), 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(step.subtitle), 1)
            ])
          ], 42, _hoisted_4))
        }), 128))
      ])
    ])
  ], 2))
}
}

})